import React from 'react';
import Services from '../../Components/Services/Services';

const ServicePage = () => {
    return (
        <div>
            <Services></Services>
        </div>
    );
};

export default ServicePage;